import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";

// Firebase config
const firebaseConfig = {
    apiKey: "AIzaSyDU-m2dMdK1YKi2_3B_2JQXs1aVUsQi06U",
    authDomain: "finger-schreiben-lernen.firebaseapp.com",
    projectId: "finger-schreiben-lernen",
    storageBucket: "finger-schreiben-lernen.appspot.com",
    messagingSenderId: "277403506248",
    appId: "1:277403506248:web:843eb9448c4e41e78f2a7d",
    measurementId: "G-5J38CB3Y4X"
};

// Initialize Firebase only on client side
let auth;
let db;
let app;

if (typeof window !== "undefined") {
    // Initialize only once
    if (!app) {
        app = initializeApp(firebaseConfig);
        auth = getAuth(app);
        db = getFirestore(app);
        
        // Enable Firestore offline persistence
        enableIndexedDbPersistence(db)
            .catch((err) => {
                if (err.code === 'failed-precondition') {
                    console.warn('Persistence failed - multiple tabs open');
                } else if (err.code === 'unimplemented') {
                    console.warn('Persistence not available in this browser');
                }
            });
        
        // Lazy load analytics only when needed
        if (process.env.NODE_ENV === 'production') {
            const loadAnalytics = () => {
                import("firebase/analytics").then(({ getAnalytics }) => {
                    getAnalytics(app);
                });
            };
            
            // Load analytics after page has loaded
            if (document.readyState === 'complete') {
                loadAnalytics();
            } else {
                window.addEventListener('load', loadAnalytics);
            }
        }
    }
} else {
    // Server-side initialization for SSR
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    db = getFirestore(app);
}

export { auth, db };
